import * as Oazapfts from 'oazapfts/lib/runtime'
import * as QS from 'oazapfts/lib/runtime/query'
import { defaults } from '@/api'
import { apiFetch } from '@/api/apiFetch'
import { apiConfig } from '@/config'
import type {
  InAppNotificationListResponse,
  InAppNotificationPulse,
  NotificationsPulseResult,
} from './types'

const oazapfts = Oazapfts.runtime(defaults)

const getAuthHeaders = (): Record<string, string> => {
  const base = defaults.headers ?? {}
  const headers: Record<string, string> = {
    Accept: 'application/json',
  }
  if (typeof base === 'object' && base !== null) {
    for (const [key, value] of Object.entries(base)) {
      if (typeof value === 'string') {
        headers[key] = value
      }
    }
  }
  return headers
}

export async function getNotificationsPulse(
  _ifNoneMatch?: string
): Promise<NotificationsPulseResult> {
  const headers = getAuthHeaders()

  const response = await apiFetch(`${apiConfig().apiUrl}/notifications/pulse`, {
    method: 'GET',
    headers,
    cache: 'no-store',
  })

  if (response.status === 304) {
    return { status: 304 }
  }

  if (response.status === 200) {
    const data = (await response.json()) as InAppNotificationPulse
    return {
      status: 200,
      data,
      etag: undefined,
    }
  }

  throw new Error(`getNotificationsPulse failed with status ${response.status}`)
}

export async function listInAppNotifications(params?: {
  limit?: number
  cursor?: string
}): Promise<InAppNotificationListResponse> {
  const query = QS.query(
    QS.explode({
      ...(params?.limit != null ? { limit: params.limit } : {}),
      ...(params?.cursor ? { cursor: params.cursor } : {}),
    })
  )

  return oazapfts.ok(
    oazapfts.fetchJson<{
      status: 200
      data: InAppNotificationListResponse
    }>(`/notifications${query}`, {
      method: 'GET',
    })
  )
}

export async function markInAppNotificationRead(
  notificationId: string
): Promise<Record<string, never>> {
  return oazapfts.ok(
    oazapfts.fetchJson<{
      status: 200
      data: Record<string, never>
    }>(`/notifications/${encodeURIComponent(notificationId)}/read`, {
      method: 'PATCH',
    })
  )
}

export async function markAllInAppNotificationsRead(): Promise<
  Record<string, never>
> {
  return oazapfts.ok(
    oazapfts.fetchJson<{
      status: 200
      data: Record<string, never>
    }>('/notifications/mark-all-read', {
      method: 'POST',
    })
  )
}

export async function clearAllInAppNotifications(): Promise<
  Record<string, never>
> {
  return oazapfts.ok(
    oazapfts.fetchJson<{
      status: 200
      data: Record<string, never>
    }>('/notifications/clear', {
      method: 'POST',
    })
  )
}
